import type { JsonValue } from '@lotushealth/lotushealth_js_sdk/schemas';

type BaseSource = { externalId: string };
type RevisionSource = BaseSource & { isRevision: true; revisionReason: string };

export type SourceProposedActionT = BaseSource | RevisionSource;

export function isRevisionFlow(
  source: SourceProposedActionT | null | undefined
): source is RevisionSource {
  return source != null && 'isRevision' in source && source.isRevision === true;
}

export function buildRevisionToolOutput(
  source: RevisionSource,
  toolOutput?: Record<string, JsonValue> | null
): Record<string, JsonValue> {
  return {
    ...(toolOutput ?? {}),
    revision_reason: source.revisionReason,
  };
}
